module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2021_26.477e4860.jpg";